import { render } from "./CommentNode.vue?vue&type=template&id=a77b1f4a"
import script from "./CommentNode.vue?vue&type=script&lang=js"
export * from "./CommentNode.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__